// @flow
import { RESORT_FLASH_INFO } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_FLASH_INFO } from 'Utils/request/requestDictionary';

type LineProps = {
  resortId: string,
  seeMore: string,
  title: string,
};

export const productFlashInfoResolver = {
  name: RESORT_FLASH_INFO,
  resolve: (
    appContext: AppContext,
    props: LineProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ) => {
    const { resortId } = props;
    const { urlParams } = location;
    const productArgs = buildProductArgs(resortId, urlParams);
    const query = `query {
      config {
        common { close }
      }
      editorialZone(${productArgs}) {
        texts
        image
        link
      }
    }`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_FLASH_INFO,
      strictErrors: false,
    });
  },
};
